import { AppCoreModule } from '@opengov/app-core';
import { AnalyticsModule, SegmentEffects } from '@opengov/app-core/analytics';
import { ready } from '@opengov/app-core/routes';
import { ComponentLibraryModule } from '@opengov/component-library-classic/module';
import { composeApp } from '@opengov/compose-app';
import { RouterModule } from '@opengov/compose-app-router';
import { LocaleModule } from '@opengov/locale';
import { ISession } from '@opengov/og-api-ts';

import { actionsToTrack } from './actionsToTrack';
import { initialize } from './instrumentation/grafanaFaro/initialize';
import { StoriesModule } from './index';
import { renderer } from './renderer';
import { routes } from './routes';

const onReady = async (session: ISession) => {
  initialize(session);
};

// composeApp() returns the assembled store (see
// node_modules/@opengov/compose-app/index.js: linkStoreAndView returns store).
// Returning it here lets future callers reach the store without resorting to
// the module-level `dispatch` singleton from @opengov/compose-app/dispatch.
// Today only `app.ts` calls this and ignores the return value; reserved for
// follow-up work (e.g. a RESET_APP action dispatched from PSP unmount).
export const createStore = () =>
  composeApp(
    [
      RouterModule({ routes, readyForRoutes: ready(onReady), pageTrackingCallback: SegmentEffects.page }),
      StoriesModule,
      AnalyticsModule({ trackableActions: actionsToTrack }),
      LocaleModule,
      AppCoreModule,
      ComponentLibraryModule
    ],
    renderer
  );
